import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideUpdateNotificationGuard } from '@interserve/angular';

import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // 更新検知: 猶予付き強制更新と促す更新を UX で表示
    ...provideUpdateNotificationGuard({
      versionUrl: '/version.json',
      checkIntervalMs: 60 * 1000, // 60秒ごとにチェック
      criticalGraceSeconds: 10,
    }),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
  ],
};
